module.exports = __webpack_public_path__ + "media/images/icons/account-veiling-9d072648690f5962a63ecbaee8e1d630.svg";